import { useIntl } from "@grandvisionhq/state";
import { useRxGlassesConfiguratorContext } from "../../../../../../../../context/context/RxGlassesConfiguratorContext.js";
import { PD_LINK_DRAWER_TRIGGER_LABEL } from "../../../../../steps/components/PupillaryDistanceLink/types.js";
const usePupillaryDistanceDrawerLink = () => {
  const { hasLabel } = useIntl();
  const { configuratorDocument } = useRxGlassesConfiguratorContext();
  const hasMeasurementInformation = configuratorDocument?.prescriptionStep?.measureDescription;
  return Boolean(hasLabel(PD_LINK_DRAWER_TRIGGER_LABEL) && hasMeasurementInformation);
};
export {
  usePupillaryDistanceDrawerLink
};
//# sourceMappingURL=use-pupillary-distance-drawer-link.js.map
